import React from 'react';
import { Hero } from './components/Hero';
import { FlagStripe } from './components/FlagStripe';
import { Crisis } from './components/Crisis';
import { AIEngine } from './components/AIEngine';
import { JurisdictionCoverage } from './components/JurisdictionCoverage';
import { ComplianceSeals } from './components/ComplianceSeals';
import { Pricing } from './components/Pricing';
import { Leadership } from './components/Leadership';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-midnight min-h-screen" data-id="element-0">
      <Hero data-id="element-1" />
      <FlagStripe data-id="element-2" />
      <Crisis data-id="element-3" />
      <FlagStripe thick data-id="element-4" />
      <AIEngine data-id="element-5" />
      <FlagStripe data-id="element-6" />
      <JurisdictionCoverage data-id="element-7" />
      <FlagStripe thick data-id="element-8" />
      <ComplianceSeals data-id="element-9" />
      <FlagStripe data-id="element-10" />
      <Pricing data-id="element-11" />
      <FlagStripe thick data-id="element-12" />
      <Leadership data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}